const Config = {
    INTRO_END_MS: 3000,
};

export default Config;
